
    <app-kontable
      id="dt_brand"
      title="{{ 'promotion.campaignTitle' | translate }}"
      [columns]="['code', { field: 'start_date', title: 'customerInfoSheet.startDate'}, { field: 'end_date', title: 'customerInfoSheet.endDate'}, 'small_description']"
      [titles]="['promotion.code', 'promotion.smallDescription' ]"
      [service]="svcCampaign"
      [paginationType]="paginationType"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      [name]="'promotion.messageTable'"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-campaign-detail
        *ngIf="show"
        (hide)="toggleShow()"
        [titlePage]="titlePage"
        [wizardCampaigns]="wizardCampaigns"
        [addEditCampaign]="addEditCampaign"
        [campaignTypes]="campaignTypes"
        [touchPoints]="touchPoints">
    </kv-promo-campaign-detail> 
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/campaign.component.ts.CampaignComponent.html